import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';

import { useAPI } from 'hooks/api/useAPI';

type UseCreateStreamSnapshotParams = { stream_id: string; gateway_id?: string };

export function useCreateStreamSnapshot({
  onSettled,
  onMutate,
  ...options
}: UseMutationOptions<
  { file_id: string },
  APIError,
  UseCreateStreamSnapshotParams
> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async ({ stream_id, ...params }) => {
      const { data } = await client.post(
        `/apps/${applicationID}/streams/${stream_id}/snapshot`,
        params
      );

      return data;
    },
    {
      ...options,
      onSettled: (...args) => {
        onSettled?.(...args);

        queryClient.invalidateQueries(['files']);
        queryClient.invalidateQueries(['file']);
        queryClient.invalidateQueries(['streams']);
        queryClient.invalidateQueries(['stream']);
        queryClient.invalidateQueries(['video-sources']);
      },
    }
  );
}
